import React, { Component } from 'react'
import { connect } from 'react-redux'

import './Challenge.css'

import Page from '../../Components/Page'
import Card from '../../Components/Card'

import Input from '../../Components/Input'

import * as actions from './actions'


const ms = state => ({
    ...state.challengeState
})

class Challenge extends Component {

    constructor(props) {
        super(props)
        this.state = {
            name: '',
            who: '',
            tSize: 'S'
        }
    }

    accept = () => {
        const { acceptChallenge, history } = this.props
        const { name, who, tSize } = this.state
        
        history.push('\subscribe')

        acceptChallenge(this.state)
    }

    onChange = (e, key) => {
        this.setState({ [key]: e.target.value })
    }

    render() {

        const { history } = this.props
        const { name, who, tSize } = this.state

        return (
            <Page>
                <Card>
                    <div className="center">
                        <h1 className="title2">Challenge yourself.</h1>
                        <form>
                        <div><input placeholder="Name" onChange={(e) => this.onChange(e, "name")} value={name} /></div>
                        <div><textarea placeholder="Who do you run for?" value={who} onChange={(e) => this.onChange(e, "who")}></textarea></div>
                        <div className="tshirt">
                            <p>Get a FREE T-Shirt</p>
                            <select style={{ margin: '0 10px' }} value={tSize} onChange={(e) => this.onChange(e, "tSize")}>
                                <option value="S">S</option>
                                <option value="M">M</option>
                                <option value="L">L</option>
                                <option value="XL">XL</option>
                            </select>
                        </div>           
                        </form>
                        <button className="accept_btn" onClick={this.accept}>Accept</button>
                    </div>
                </Card>
            </Page>
        )
    }

}

export default connect(ms, actions)(Challenge);


// WEBPACK FOOTER //
// ./src/Pages/Challenge/index.js